import { gql } from '@grandvisionhq/graphql';
import { commercialCategoryFragment, frameFeaturesFragment, lensFeaturesFragment } from './fragments/small-fragments.js';
import './fragments/prices/productPriceItem.js';
import './fragments/prices/productPrice.js';
import './fragments/offerings.js';
import { productFragment } from './fragments/product.js';
import { variantFragment } from './fragments/variant.js';

const GET_SUNGLASSES_BY_SLUG = gql`
  query GetSunglassesBySlug($slug: String!) {
    getProductBySlug(slug: $slug) {
      product {
        __typename
        ... on SunglassesProduct {
          id
          ...productFragment
          commercialCategories {
            ...CommercialCategoryFragment
          }
          productTypeDetails {
            isExclusiveBrand
            isOfferedWithPrescriptions
          }
          variants {
            ...variantFragment
            variantTypeDetails {
              channelAvailability
              recommendedCategoryKey
              brandModel
              brandModelCode
              brandModelColorCode
              targetGender
              targetGenderAllLocales {
                value
                locale
              }
              isReservable
              isVtoEnabled
              trend
              frameFeatures {
                ...frameFeaturesFragment
              }
              lensFeatures {
                ...lensFeaturesFragment
              }
              faceShape {
                shape
                displayNameAllLocales {
                  locale
                  value
                }
              }
              segment
              roadworthiness
            }
          }
        }
      }
    }
  }
  ${productFragment}
  ${commercialCategoryFragment}
  ${variantFragment}
  ${frameFeaturesFragment}
  ${lensFeaturesFragment}
`;

export { GET_SUNGLASSES_BY_SLUG };
//# sourceMappingURL=get-sunglasses-by-slug.js.map
